/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext } from 'react';

// service imports
import AuthService from '../../services/AuthService';

// context imports
import { AuthContext } from '../../contexts/AuthContext';

const AdminSidebar = props => {

    // contexts
    const { user, setUser, isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

    // handle functions
    const handleLogout = () => {
        AuthService.logout()
            .then(data => {
                setUser(data.user);
                setIsAuthenticated(false);
                // props.history.push('/');
            });
    };

    const handleSelectedTab = e => {
        document.getElementById("dashboardContainer").classList.toggle("sb-sidenav-toggled");
        props.setSelectedTab([e.target.id].toString());
    }

    return (
        <div id="layoutSidenav_nav">
            <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                <div className="sb-sidenav-menu">
                    <div className="nav">
                        <a className="nav-link" id="dashboard" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>
                            Dashboard
                        </a>
                        <div className="sb-sidenav-menu-heading">Users</div>
                        <a className="nav-link" id="clients" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-user"></i></div>
                            Clients
                        </a>
                        <a className="nav-link" id="providers" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-user-md"></i></div>
                            Counsellors
                        </a>
                        <a className="nav-link" id="demoUsers" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-user"></i></div>
                            Demo Users
                        </a>

                        <div className="sb-sidenav-menu-heading">Subscription Plans</div>
                        <a className="nav-link" id="providerSubscriptionPlans" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                            Counsellor Subscription Plans
                        </a>

                        {/* <a className="nav-link" id="organisationSubscriptionPlans" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                            Organisation Subscription Plans
                        </a> */}

                        <div className="sb-sidenav-menu-heading">Approve</div>
                        <a className="nav-link" id="approveProviders" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                            Approve Counsellors
                        </a>

                        {/* <a className="nav-link" id="approveOrganisations" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                            Approve Organisations
                        </a> */}
                        <div className="sb-sidenav-menu-heading">Pyschometric Tests</div>
                        <a className="nav-link" id="addOrganization" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-briefcase-medical"></i></div>
                            Add Psychometric Organization
                        </a>
                        <a className="nav-link" id="psychometricOrganizations" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-briefcase-medical"></i></div>
                             Psychometric Organization List
                        </a>
                        <a className="nav-link" id="psychometricUsers" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-briefcase-medical"></i></div>
                             Psychometric Candidate List
                        </a>
                        <div className="sb-sidenav-menu-heading">Claim Counsellors Profile</div>
                        <a className="nav-link" id="claimCounsellorProfileRequests" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                            Claim Counsellors Profile requests
                        </a>

                        <a className="nav-link" id="scrapedCounsellorProfiles" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                            Scraped Counsellor Profiles
                        </a>

                        <div className="sb-sidenav-menu-heading">Edit</div>
                        <a className="nav-link" id="addProviders" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-briefcase-medical"></i></div>
                            Add Counsellor
                        </a>
                        <a className="nav-link" id="replaceProvider" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-hospital-user"></i></div>
                            Replace Counsellor
                        </a>
                        <a className="nav-link" id="services" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-hospital-user"></i></div>
                            Services
                        </a>
                        <a className="nav-link" id="serviceRequests" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-hospital-user"></i></div>
                            Service Requests
                        </a>
                        <div className="sb-sidenav-menu-heading">Lists</div>
                        <a className="nav-link" id="sessions" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-headset"></i></div>
                            Sessions
                        </a>
                        <a className="nav-link" id="payments" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-money-bill-alt"></i></div>
                            Payments
                        </a>
                        <a className="nav-link" id="refunds" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-money-bill-alt"></i></div>
                            Refunds
                        </a>
                        <a className="nav-link" id="audits" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-clipboard"></i></div>
                            Audit log
                        </a>
                        <a className="nav-link" id="coupons" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-ticket-alt"></i></div>
                            Coupons
                        </a>
                        <a className="nav-link" id="giftVouchers" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-gift"></i></div>
                            Gift Vouchers
                        </a>
                        <a className="nav-link" id="transactions" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-money-bill-alt"></i></div>
                            Transactions
                        </a>
                        <a className="nav-link" id="forms" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fab fa-wpforms"></i></div>
                            Client Forms
                        </a>
                        <a className="nav-link" id="providerForms" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fab fa-wpforms"></i></div>
                            Provider Forms
                        </a>
                        <a className="nav-link" id="faqs" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fab fa-wpforms"></i></div>
                            FAQs
                        </a>
                        <a className="nav-link" id="policies" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fab fa-wpforms"></i></div>
                            Policies
                        </a>
                        <div className="sb-sidenav-menu-heading">Other</div>
                        <a className="nav-link" id="settings" style={{ cursor: "pointer" }} onClick={handleSelectedTab}>
                            <div className="sb-nav-link-icon"><i className="fas fa-cog"></i></div>
                            Settings
                        </a>
                        <div className="sb-sidenav-menu-heading"></div>
                        <a className="nav-link" id="logout" style={{ cursor: "pointer" }} onClick={handleLogout}>
                            <div className="sb-nav-link-icon"><i className="fas fa-sign-out-alt"></i></div>
                            Logout
                        </a>
                    </div>
                </div>
                <div className="sb-sidenav-footer">
                    <div className="small">Logged in as:</div>
                    {user.username}
                </div>
            </nav>
        </div>

    )


};

export default AdminSidebar;